import React, { useState, useEffect } from "react";
import "../../scss/Dashboard.css";
import { Tab, Tabs, TabList } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useDispatch, useSelector } from "react-redux";
import eye from "../../assets/eye_159078.png";
import { toast } from "react-toastify";

import { ExportToExcelGeneric } from "../../Utils/GenerateExcel";

import { allDataThunk, allData } from "../../redux/allDataSlice";
import { genericReport } from "../../Utils/reportGenerator";

const reportSuffix=" attendance";

const AttendanceSubReport = () => {
  const dispatch = useDispatch();
  const [selectedCeremonies, setSelectedCeremonies] = useState([]);
  const [guestList, setGuestList] = useState([]);
  const [reportName, setReportName] = useState("All");
  const [guestListLoading, setGuestListLoading] = useState(true);
  const allDataLoaded = useSelector((state) => state.allData.loaded);
  const allDataChanged = useSelector((state) => state.allData.changed);

  const exportData = () => {
    const data = [["Name", "Guest of", "Email", "Mobile", "Group"]];
    const ceremonies = allData.ceremonies.map(c=>c.ceremony_name);
    for (const ceremony of ceremonies) {
      data[0].push("Attending " + ceremony);
    }
    for (const guest of guestList) {
      const dat = [
        guest?.guest_name,
        guest?.parentGuest?.guest_name,
        guest?.email,
        guest?.mobile_number,
        guest?.group_name,
      ];
      for (const ceremony of ceremonies) {
        dat.push((guest?.attendance?.indexOf(ceremony)>=0) ? "yes" : "no");
      }
      data.push(dat);
    }
    return data;
  }

  const asArray = (a) => {
    if (Array.isArray(a)) return a;
    if (a===undefined || a===null) return [];
    return [a];
  }

  const getReport=() => {
    const result = genericReport(allData, ["attendance"]);
    // strip any unexpected ceremonies (eg, "cannot attend"), and only keep results with something left
    const ceremonies = allData.ceremonies.map(c=>c.ceremony_name);
    const filteredResult = result.filter(d=>{
      return asArray(d.attendance).filter(d=>ceremonies.indexOf(d)>=0).join("").length > 0;
    });
    return filteredResult;
  }

  const handleTabClick = async (ceremonyName) => {
    try {
      const result = getReport();
      if (ceremonyName==="") {
        setGuestList(result);
        setReportName("All");
      } else{
        const filteredResult = result.filter(d=>d.attendance.indexOf(ceremonyName)>=0);
        setGuestList(filteredResult);
        setReportName(ceremonyName);
      }
    } catch (e) {
      console.log("handleTabClick", e);
      toast.error("failed");
    }
  };
  useEffect(() => {
    dispatch(allDataThunk());
  }, []);

  useEffect(()=>{
    if (!allDataLoaded) {
      return;
    }

    const selectedCeremonyNames = allData.ceremonies.map((item) => ({
      name: item.ceremony_name,
      id: item.id,
      icon: item.icon_link,
    }));
    setSelectedCeremonies(selectedCeremonyNames);

    const result = getReport();
    console.log("report", result);
    setGuestList(result);
    setGuestListLoading(false);
  }, [allDataChanged]);

  return (
    <div>
      <div className="row gust-box my-4">
        <div className="col-12">
          <div className="tabs-home">
            <Tabs>
              <TabList>
                <Tab>
                  <div className="" onClick={() => handleTabClick("")} >
                    <span>All ceremonies</span>
                  </div>
                </Tab>

                {selectedCeremonies?.map((item) => (
                  <Tab>
                    <div className="" onClick={() => handleTabClick(item.name)} >
                      <span>{item.name}</span>
                    </div>
                  </Tab>
                ))}
              </TabList>

              <div className="gray-box mt-3 menu-tabing clearfix">
                <div className="gray-box-inv clearfix">
                    {reportName + reportSuffix}
                  <div className="sky-circle d-inline-block">
                    {guestList?.length}
                  </div>
                  <ExportToExcelGeneric dataFn={exportData} fileName={reportName + reportSuffix} />
                </div>

                <TabList>
                  {guestListLoading ? (
                    <h5>Loading...</h5>
                  ) : guestList?.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Guest of</th>
                            <th>Email</th>
                            <th>Mobile Number</th>
                            <th>Group</th>
                            <th>RSVP</th>
                          </tr>
                        </thead>
                        <tbody>
                          {guestList?.map((guest, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{guest?.guest_name}</td>
                                <td>{guest?.parentGuest?.guest_name}</td>
                                <td>{guest?.email}</td>
                                <td>{guest?.mobile_number}</td>
                                <td>{guest?.group_name}</td>

                                <td className="text-center">
                                  {(guest?.rsvp_code || guest?.parentGuest?.rsvp_code) && 
                                    <a href={"/rsvp/code/"+(guest.rsvp_code || guest?.parentGuest?.rsvp_code)} target="_blank">
                                      <img
                                        className="action-icon"
                                        width={20}
                                        src={eye}
                                        alt={"rsvp for " + guest?.guest_name}
                                      />
                                    </a>
                                  }
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <h4 className="not-found">No Data Found</h4>
                  )}
                </TabList>
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceSubReport;
